import React, { memo } from 'react';

import GroupDropdown from '../GroupDropdown';

import { useLoanActionsControlsContext } from './hooks';

const LoanActionsControlsGroupedSlot = () => {
  const {
    isDataLoaded,
    isMobile,
    groupedActions,
    executingActionId,
    disabledLoanActionsSet,
    runningLoanActionsSet,
    onConfirmLoanAction,
  } = useLoanActionsControlsContext();

  if (!isDataLoaded || isMobile) {
    return null;
  }

  return (
    <>
      {groupedActions.namedGroups.map(([groupName, actions]) => (
        <GroupDropdown
          actions={actions}
          disabledLoanActionsSet={disabledLoanActionsSet}
          executingActionId={executingActionId}
          groupName={groupName}
          key={groupName}
          runningLoanActionsSet={runningLoanActionsSet}
          onConfirmLoanAction={onConfirmLoanAction}
        />
      ))}
    </>
  );
};

export default memo(LoanActionsControlsGroupedSlot);
